import { lang } from '@public/utils/filters'
export default {
  V_timeDimension: [
    { value: 1, label: lang('日报'), name: lang('日报') },
    { value: 2, label: lang('月报'), name: lang('月报') },
    { value: 3, label: lang('自定义查询'), name: lang('自定义查询') }
  ],
  V_dateType: [
    { value: 1, label: lang('拨打时间'), name: lang('拨打时间') },
    { value: 2, label: lang('申诉时间'), name: lang('申诉时间') }
  ],
  V_countDimension: [
    { value: 3, label: lang('服务商'), name: lang('服务商') },
  ],
  V_isQualified: [
    { value: 1, label: lang('合格'), name: lang('合格') },
    { value: 0, label: lang('不合格'), name: lang('不合格') }
  ],
  V_appealResultList: [
    { value: 1, label: lang('合格'), name: lang('合格') },
    { value: 2, label: lang('不合格'), name: lang('不合格') }
  ],
  V_customerList: [
    { value: 1, label: lang('满意'), name: lang('满意') },
    { value: 2, label: lang('不满意'), name: lang('不满意') },
    { value: 2, label: lang('未评价'), name: lang('未评价') }
  ],
  V_appealStatus: [
    { value: 0, label: lang('未申诉'), name: lang('未申诉') },
    { value: 1, label: lang('待复核'), name: lang('待复核') },
    { value: 2, label: lang('已复核'), name: lang('已复核') },
    { value: 3, label: lang('已完结'), name: lang('已完结') }
  ],
  V_hangupList: [
    { value: 0, label: lang('客服'), name: lang('客服') },
    { value: 1, label: lang('客户'), name: lang('客户') }
  ]
}
